<!--评论-->
<template>
    <div class="comment">
        <div v-if="list" class="comment-list">
            <div class="comment-item" v-for="(item,index) in list" :key="index">
                <DynamicUserInfo :showTags="false" size="Small" :data="item.account" :desc="item.cdate"/>
                <DynamicContent :onDownClick="onDownClick" :resource="item.resource ? JSON.parse(item.resource) : undefined" :text="item.content"
                                :voice="item.voice ? JSON.parse(item.voice) : undefined"/>
            </div>
        </div>
        <div v-on:click="onDownClick()" class="download">
            <span>下载足趣社区，查看更多相关内容</span>
            <img src="../../../assets/images/common/go.svg" alt="">
        </div>
    </div>
</template>

<script>
    import DynamicUserInfo from './UserInfo';
    import DynamicContent from './Content';

    export default {
        components: {
            DynamicUserInfo,
            DynamicContent,
        },
        props: {
            list: [Array],
            // 下载按钮点击事件
            onDownClick: [Function],
        },
    }
</script>

<style scoped>
    .comment-item {
        border-bottom: 1px solid #DDD;
        padding: 1rem;
    }

    .download {
        margin: 3rem auto;
        text-align: center;
        padding: 0.4rem 1rem;
        overflow: hidden;
        background: #764BF8;
        color: #FFF;
        border-radius: 0.2rem;
        display: inline-flex;
        align-items: center;
        position: relative;
        left: 50%;
        transform: translate(-50%, 0);
    }

    .download img {
        height: 1em;
        margin-left: 10px;
    }
</style>